module.exports = __webpack_public_path__ + "static/media/downlines-icon.15690bf9.svg";